function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * @description Dialog
 * @param {Boolean} isOpen   控制弹窗的显示隐藏 默认false
 * @param {Boolean} maskCloseAble  点击蒙层是否允许关闭 默认false
 * @param {Boolean} isShowFoot  是否显示底部按钮 默认false
 * @param {String} title  标题 默认 ''
 * @param {Boolean} closeOpen  关闭叉显示否 默认true
 * @param {Boolean} okDisabled  确认按钮禁用否 默认false
 * @param {String} cancelTxt  取消按钮文本 默认 ''
 * @param {String} okTxt  确认按钮文本 默认 ''
 * @param {Function} onOk  确认事件
 * @param {Function} onClose  关闭事件
 * @param {Function} onCancel  取消事件
 * @param {Object} classNames  样式类名 {box: '', head: '', footer: ''}
 * @param {React.ReactNode} children   内容

 * * @param {Function} onCancel  取消事件
 */
import { Button, Icon } from "./..";
import React, { useEffect, useState } from 'react';
import "./index.less";
var Dialog = function Dialog(props) {
  var id = props.id,
    isOpen = props.isOpen,
    title = props.title,
    maskCloseAble = props.maskCloseAble,
    cancelTxt = props.cancelTxt,
    okTxt = props.okTxt,
    classNames = props.classNames,
    onClose = props.onClose,
    children = props.children,
    isShowFoot = props.isShowFoot,
    onOk = props.onOk,
    onCancel = props.onCancel,
    closeOpen = props.closeOpen,
    okDisabled = props.okDisabled;
  var _useState = useState(isOpen),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var dialogId = id ? "".concat(id, "-dialog") : '';
  var okBtnId = id ? "".concat(id, "-dialog-okBtn") : '';
  var cancelBtnId = id ? "".concat(id, "-dialog-cancelBtn") : '';
  var closeBtnId = id ? "".concat(id, "-dialog-closeBtn") : '';
  useEffect(function () {
    setVisible(isOpen);
    if (isOpen) {
      document.body.style.overflow = 'hidden'; // 禁止滚动
    } else {
      document.body.style.overflow = 'auto'; // 恢复滚动
    }

    // 清理函数：组件卸载时恢复页面滚动
    return function () {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);
  function hideDialog() {
    if (maskCloseAble && onClose) {
      onClose();
    }
  }
  var handleClose = function handleClose() {
    if (onClose) {
      onClose();
    }
  };
  var handleCancel = function handleCancel() {
    if (onCancel) {
      onCancel();
    }
  };
  var handleOk = function handleOk() {
    if (onOk) {
      onOk();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "iron-modal ".concat(classNames !== null && classNames !== void 0 && classNames.all ? classNames === null || classNames === void 0 ? void 0 : classNames.all : ''),
    id: dialogId
  }, visible && /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      hideDialog();
    },
    className: "iron-fix-layer iron-modal-layer animate__animated animate__fadeIn"
  }), /*#__PURE__*/React.createElement("div", {
    className: "iron-modal-wrap animate__animated ".concat(visible ? 'show' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-modal-box ".concat(classNames !== null && classNames !== void 0 && classNames.box ? classNames === null || classNames === void 0 ? void 0 : classNames.box : '')
  }, closeOpen && /*#__PURE__*/React.createElement("span", {
    id: closeBtnId,
    onClick: handleClose,
    className: "iron-modal-close"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "cross"
  })), title && /*#__PURE__*/React.createElement("p", {
    className: "iron-modal-title ".concat(classNames !== null && classNames !== void 0 && classNames.head ? classNames === null || classNames === void 0 ? void 0 : classNames.head : '')
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "iron-modal-content"
  }, children), isShowFoot && /*#__PURE__*/React.createElement("div", {
    className: "iron-modal-footer ".concat(classNames !== null && classNames !== void 0 && classNames.footer ? classNames === null || classNames === void 0 ? void 0 : classNames.footer : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-modal-footer-inner"
  }, cancelTxt && /*#__PURE__*/React.createElement(Button, {
    id: cancelBtnId,
    size: "large",
    onClick: handleCancel
  }, cancelTxt), okTxt && /*#__PURE__*/React.createElement(Button, {
    id: okBtnId,
    type: "primary",
    size: "large",
    disabled: okDisabled,
    onClick: handleOk
  }, okTxt))))));
};
Dialog.defaultProps = {
  isOpen: false,
  title: ' ',
  classNames: {
    all: '',
    box: '',
    head: '',
    footer: ''
  },
  maskCloseAble: false,
  okTxt: '',
  cancelTxt: '',
  isShowFoot: true,
  closeOpen: true,
  okDisabled: false
};
export default Dialog;